import React from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CRow,
  CAlert,
  CButton,
  CCardHeader,
} from "@coreui/react";

import Loader from "components/Loader";
import Header from "components/Header";
import { useCancel } from "context/cancelContext";
import { useHistory } from "react-router-dom";

import Form from "./components/Form";
import Table from "./components/Table";

function Cancel() {
  const { showForm, showSuccess } = useCancel();
  const history = useHistory();
  return (
    <CContainer>
      <CRow className="justify-content-center">
        <Header text="BIENVENIDO AL SERVICIO DE CANCELACIÓN DE RESERVA DE LA IGLESIA EL CAMINO" />
      </CRow>
      <CRow className="justify-content-center">
        <CCol xs="12" md="9" lg="7" xl="6">
          {showSuccess && (
            <CAlert color="success">Reserva cancelada con éxito.</CAlert>
          )}
          <CCard>
            <CCardHeader>
              <CButton onClick={history.goBack} color="info" size="sm">
                  Regresar al portal de reservas
                </CButton>
            </CCardHeader>
            <CCardBody>{showForm ? <Form /> : <Table />}</CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
}

export default Loader((props) => props.loading)(Cancel);
